<template>
    <div class="event-add-view">
        <h1>
            Новое событие
        </h1>

        <event-form />
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { ROUTES } from '@/enums';
import EventForm from '../components/EventForm';
import breadcrumbs from '@/mixins/breadcrumbs';

export default {
    name: 'EventAddView',

    components: {
        EventForm
    },

    mixins: [
        breadcrumbs
    ],

    computed: {
        $breadcrumbs() {
            return [
                {
                    title: 'События',
                    route: ROUTES.EVENT.LIST
                },
                {
                    title: 'Создание нового события',
                    route: ROUTES.EVENT.ADD
                }
            ];
        }
    }
};
</script>

<style lang="scss">
    @import "@vars";

</style>
